// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-pane {
	display: table-cell;
	position: relative;
	height: 100%;
	width: 100%;
	padding: 10px;
	border-collapse: separate;
}

.designer-stage {
	display: inline-block;
	width: 100%;
	height: auto;
	min-height: 90%;
	background: #fff;

	border: 1px solid #d5d5d5;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;

	box-shadow: 0px 0px 10px rgba(0,0,0,0.25);
}`, "",{"version":3,"sources":["webpack://./assets/style/partials/stage.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;;CAEhB,yBAAyB;CACzB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,yCAAyC;AAC1C","sourcesContent":[".editor-pane {\r\n\tdisplay: table-cell;\r\n\tposition: relative;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\tpadding: 10px;\r\n\tborder-collapse: separate;\r\n}\r\n\r\n.designer-stage {\r\n\tdisplay: inline-block;\r\n\twidth: 100%;\r\n\theight: auto;\r\n\tmin-height: 90%;\r\n\tbackground: #fff;\r\n\r\n\tborder: 1px solid #d5d5d5;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\r\n\tbox-shadow: 0px 0px 10px rgba(0,0,0,0.25);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
